import { render, staticRenderFns } from "./AdminSignUp.vue?vue&type=template&id=504df4b0&scoped=true&"
import script from "./AdminSignUp.vue?vue&type=script&lang=js&"
export * from "./AdminSignUp.vue?vue&type=script&lang=js&"
import style0 from "./AdminSignUp.vue?vue&type=style&index=0&id=504df4b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504df4b0",
  null
  
)

export default component.exports